module.exports = __webpack_public_path__ + "img/2.d1f9aa73.jpg";